/**
 * Настройки тоста об истечении подписки. Регулируются только здесь (хардкод на фронте):
 * бэкенд про эти пороги ничего не знает.
 */
export const SUBSCRIPTION_EXPIRY_NOTICE = {
  /** За сколько календарных дней до окончания начинать предупреждать. */
  warnWithinDays: 7,
  /** Минимальный интервал между двумя показами тоста, в часах. */
  cooldownHours: 24,
  /** Сколько миллисекунд висит тост (глобальные 3000 мс для такого сообщения мало). */
  autoCloseMs: 10_000,
} as const;

/** Префикс ключа localStorage; финальный ключ — `${PREFIX}:${tournamentId}`. */
export const SUBSCRIPTION_EXPIRY_NOTICE_STORAGE_PREFIX = 'imgame:subscriptionExpiryNotice';
